import { api } from "./api"

export const StateFetch = async () => {
    return await api.get(`get/states`)
}

export const DistrictFetch = async (state) => {
    return await api.get(`get/district?state=${state}`)  
}

export const BlockFetch = async (district) => {
    return await api.get(`get/block?district=${district}`)  
}

